module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_53304249_XL-ba70449a503b4b010fefb9a93bf091bb.jpg";